/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourcePermissionsResponse } from './ResourcePermissionsResponse';
import {
    ResourcePermissionsResponseFromJSON,
    ResourcePermissionsResponseFromJSONTyped,
    ResourcePermissionsResponseToJSON,
    ResourcePermissionsResponseToJSONTyped,
} from './ResourcePermissionsResponse';

/**
 * 
 * @export
 * @interface TournamentTeamSummary
 */
export interface TournamentTeamSummary {
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    clubName?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    homeColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    awayColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    goalkeeperColor?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamSummary
     */
    playersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamSummary
     */
    officialsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentTeamSummary
     */
    receiptUploaded?: boolean;
    /**
     * 
     * @type {ResourcePermissionsResponse}
     * @memberof TournamentTeamSummary
     */
    permissions?: ResourcePermissionsResponse;
}

/**
 * Check if a given object implements the TournamentTeamSummary interface.
 */
export function instanceOfTournamentTeamSummary(value: object): value is TournamentTeamSummary {
    return true;
}

export function TournamentTeamSummaryFromJSON(json: any): TournamentTeamSummary {
    return TournamentTeamSummaryFromJSONTyped(json, false);
}

export function TournamentTeamSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'clubName': json['club_name'] == null ? undefined : json['club_name'],
        'categoryId': json['category_id'] == null ? undefined : json['category_id'],
        'categoryName': json['category_name'] == null ? undefined : json['category_name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'email': json['email'] == null ? undefined : json['email'],
        'status': json['status'] == null ? undefined : json['status'],
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'homeColor': json['home_color'] == null ? undefined : json['home_color'],
        'awayColor': json['away_color'] == null ? undefined : json['away_color'],
        'goalkeeperColor': json['goalkeeper_color'] == null ? undefined : json['goalkeeper_color'],
        'playersCount': json['players_count'] == null ? undefined : json['players_count'],
        'officialsCount': json['officials_count'] == null ? undefined : json['officials_count'],
        'receiptUploaded': json['receipt_uploaded'] == null ? undefined : json['receipt_uploaded'],
        'permissions': json['permissions'] == null ? undefined : ResourcePermissionsResponseFromJSON(json['permissions']),
    };
}

export function TournamentTeamSummaryToJSON(json: any): TournamentTeamSummary {
    return TournamentTeamSummaryToJSONTyped(json, false);
}

export function TournamentTeamSummaryToJSONTyped(value?: TournamentTeamSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'club_name': value['clubName'],
        'category_id': value['categoryId'],
        'category_name': value['categoryName'],
        'gender': value['gender'],
        'email': value['email'],
        'status': value['status'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'home_color': value['homeColor'],
        'away_color': value['awayColor'],
        'goalkeeper_color': value['goalkeeperColor'],
        'players_count': value['playersCount'],
        'officials_count': value['officialsCount'],
        'receipt_uploaded': value['receiptUploaded'],
        'permissions': ResourcePermissionsResponseToJSON(value['permissions']),
    };
}

